"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getTransitionProperty() {
    return typeof document.documentElement.style.transition === 'string' ? 'transition' : 'WebkitTransition';
}
exports.default = getTransitionProperty;
